import { isAddress } from 'viem';

/**
 * The market a /market/:id param stands for: a valid address, or any 0x string (test markets);
 * anything else is no market (''). The market page and the boot prefetch (confs/boot-prefetch.ts)
 * share it so both ask for the same MarketDetail key.
 */
export const marketAddressFromParam = (id?: string) => (id && (isAddress(id) || id.startsWith('0x')) ? id : '');
